import React, { useEffect, useState } from "react";
import { PreloaderContainer } from "./styles";
import { motion, AnimatePresence } from "framer-motion";

let hasPreloadedAlready = false;

export const Preloader: React.FC = () => {
  const [loading, setLoading] = useState(() => {
    if (hasPreloadedAlready) return false;
    if (typeof window !== "undefined") {
      if (sessionStorage.getItem("hasPreloaded")) {
        hasPreloadedAlready = true;
        return false;
      }
      const isBot = navigator.webdriver || /Lighthouse|Chrome-Lighthouse|Googlebot|bingbot|yandex|baiduspider|HeadlessChrome/i.test(navigator.userAgent);
      const isMotionReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      const hasNoAnimationsClass = document.documentElement.classList.contains("no-animations");
      if (isBot || isMotionReduced || hasNoAnimationsClass) {
        hasPreloadedAlready = true;
        return false;
      }
      sessionStorage.setItem("hasPreloaded", "true");
    }
    hasPreloadedAlready = true;
    return true;
  });

  useEffect(() => {
    if (!loading) return;

    // Lock scroll while preloader is active
    document.body.style.overflow = "hidden";

    const timer = setTimeout(() => {
      // Restore scroll BEFORE transitioning out
      document.body.style.overflow = "";
      setLoading(false);
    }, 800);

    return () => {
      // Safety net: also clear on unmount (e.g. fast-refresh)
      clearTimeout(timer);
      document.body.style.overflow = "";
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <AnimatePresence>
      {loading && (
        <PreloaderContainer
          initial={{ opacity: 1 }}
          exit={{ 
            opacity: 0,
            transition: { duration: 0.4, ease: "easeOut" }
          }}
        >
          <div className="content">
            <div className="text-wrapper">
              <h1>
                KEDAR <span>SONI</span>
              </h1>
            </div>
            <div 
              className="line"
              style={{ width: "100%" }}
            />
          </div>

          <motion.div 
            className="panel left-panel"
            exit={{ 
              x: "-100%",
              transition: { duration: 0.4, ease: [0.19, 1, 0.22, 1] }
            }}
          />
          <motion.div 
            className="panel right-panel"
            exit={{ 
              x: "100%",
              transition: { duration: 0.4, ease: [0.19, 1, 0.22, 1] }
            }}
          />
        </PreloaderContainer>
      )}
    </AnimatePresence>
  );
};
